<div class="pyramid-container">
  <div class="pyramid-list">
    @if (dataSource.data && dataSource.data.length > 0) {
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let item">{{ item.name }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let item">
            <span class="type-badge" [ngClass]="Helpers.getEntityTypeBadgeClass(item.type)">{{ item.type }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef>Category</th>
          <td mat-cell *matCellDef="let item">{{ item.category }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="subcategory">
          <th mat-header-cell *matHeaderCellDef>Subcategory</th>
          <td mat-cell *matCellDef="let item">{{ item.subcategory }}</td>
          <td mat-footer-cell *matFooterCellDef>Total:</td>
        </ng-container>

        <ng-container matColumnDef="percentage">
          <th mat-header-cell *matHeaderCellDef>Percentage</th>
          <td mat-cell *matCellDef="let item">{{ formatPercentage(item.percentage) }}</td>
          <td mat-footer-cell *matFooterCellDef class="total-percentage">
            {{ formatPercentage(getTotalPercentage()) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item" class="actions-cell">
            <div class="action-buttons">
              @if (getEntityUrl(item); as entityUrl) {
                <a mat-icon-button
                   [href]="entityUrl"
                   target="_blank"
                   rel="noopener"
                   class="open-button"
                   [matTooltip]="'Open ' + item.type + ' in new tab'"
                   (click)="$event.stopPropagation()">
                  <mat-icon>open_in_new</mat-icon>
                </a>
              }
              <button mat-icon-button
                      (click)="onEditClick(item, $event)"
                      class="edit-button">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button
                      (click)="onDeleteClick(item, $event)"
                      class="delete-button">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns;"
            (click)="onRowClick(row)"
            [class.clickable-row]="isClickable(row)"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns" class="total-row"></tr>
      </table>
    } @else {
      <div class="empty-state">
        No pyramid data available
      </div>
    }
  </div>

  @if (pyramidEntitySummaries && pyramidEntitySummaries.length > 0) {
    <div class="pyramid-cards-section">
      <div class="section-header-with-filter">
        <button mat-icon-button (click)="toggleEntityView()" [matTooltip]="showEntityTextView ? 'Show chart view' : 'Show text view'">
          <mat-icon>{{ showEntityTextView ? 'bar_chart' : 'list' }}</mat-icon>
        </button>
        <h3 class="section-title">Pyramid Distribution by Entity</h3>
      </div>

      <div class="pyramid-cards-container">
        @for (entity of pyramidEntitySummaries; track entity.entityId) {
          <app-pyramidal-item-card
            [entitySummary]="entity"
            [showTextView]="showEntityTextView"
            (deleteEntityYear)="onDeleteEntityYear($event)"></app-pyramidal-item-card>
        }
      </div>
    </div>
  }

  @if (pyramidEntitySummaries && pyramidEntitySummaries.length > 0) {
    <div class="pyramid-cards-section">
      <div class="section-header-with-filter">
        <button mat-icon-button (click)="toggleYearView()" [matTooltip]="showYearTextView ? 'Show chart view' : 'Show text view'">
          <mat-icon>{{ showYearTextView ? 'pie_chart' : 'list' }}</mat-icon>
        </button>
        <h3 class="section-title">Pyramid Distribution by Year</h3>
      </div>

      <div class="section-content">
        <div class="section-field">
          <div class="select-with-button">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Select Years</mat-label>
              <mat-select [(value)]="selectedYears" multiple (selectionChange)="onYearsSelectionChange()" [compareWith]="compareYears">
                @for (year of availableYears; track year) {
                  <mat-option [value]="year">{{ year }}</mat-option>
                }
                <mat-select-trigger>
                  <ng-container *ngIf="selectedYears && selectedYears.length > 0">
                    {{selectedYears[0] ? getYearName(selectedYears[0]) : ''}}
                    <span *ngIf="selectedYears.length > 1" class="additional-count">
                      +{{selectedYears.length - 1}} more
                    </span>
                  </ng-container>
                </mat-select-trigger>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button type="button" (click)="selectAllYears()" matTooltip="Select all years">
              <mat-icon>select_all</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="deselectAllYears()" matTooltip="Deselect all years">
              <mat-icon>deselect</mat-icon>
            </button>
          </div>
        </div>
        <div class="section-selections">
          <mat-chip-set aria-label="Selected years">
            <mat-chip class="chip-basic-item" *ngFor="let year of getSelectedYearsArray()">
              {{ getYearName(year) }}
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>

      <div class="pyramid-cards-container">
        @for (year of selectedYears; track year) {
          @if (getYearPyramids(year).length > 0) {
            <app-pyramids-year-card
              [year]="year"
              [pyramids]="getYearPyramids(year)"
              [showTextView]="showYearTextView"
              (deletePyramidYear)="onDeletePyramidYear($event)">
            </app-pyramids-year-card>
          }
        }
      </div>
    </div>
  }
</div>
